import { getDb } from './db';
export async function addToOutbox(entry) {
    const db = await getDb();
    await db.put('outbox', entry);
}
export async function getPendingOperations() {
    const db = await getDb();
    return db.getAllFromIndex('outbox', 'by-status', 'pending');
}
export async function getConflictOperations() {
    const db = await getDb();
    return db.getAllFromIndex('outbox', 'by-status', 'conflict');
}
export async function markOperationStatus(opId, status) {
    const db = await getDb();
    const entry = await db.get('outbox', opId);
    if (entry) {
        entry.status = status;
        await db.put('outbox', entry);
    }
}
export async function removeOperations(opIds) {
    const db = await getDb();
    const tx = db.transaction('outbox', 'readwrite');
    for (const id of opIds) {
        await tx.store.delete(id);
    }
    await tx.done;
}
export async function clearOutbox() {
    const db = await getDb();
    await db.clear('outbox');
}
export async function getOutboxCount() {
    const db = await getDb();
    return db.count('outbox');
}
